/**
 * Generate a UUID v4 for idempotency key
 * @returns UUID v4 string
 */
export const generateUUID = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Get idempotency key for mutation requests
 * @param method HTTP method
 * @returns Idempotency-Key header value or undefined if not applicable
 */
export const getIdempotencyKey = (method: string): string | undefined => {
  const mutationMethods = ['POST', 'PUT', 'PATCH', 'DELETE'];
  if (mutationMethods.includes(method.toUpperCase())) {
    return generateUUID();
  }

  return undefined;
};
